import { createStreamEpic } from '../../signalr/createStreamEpic'
import { fetchActivityLogDefinition } from './definition'

export default createStreamEpic('activityLog.fetch', fetchActivityLogDefinition)
